import React, { useState, useEffect } from 'react';
import { TimerIcon } from './icons.jsx';
import { formatDuration, computeRemainingSeconds } from '../utils.js';

export const TimerCountdown = ({ timer, onExpire }) => {
    const [remaining, setRemaining] = useState(() => computeRemainingSeconds(timer));

    useEffect(() => {
        setRemaining(computeRemainingSeconds(timer));
        if (!timer) return undefined;
        let cancelled = false;
        const interval = setInterval(() => {
            if (cancelled) return;
            const next = computeRemainingSeconds(timer);
            setRemaining(next);
            if (next <= 0) {
                clearInterval(interval);
                if (onExpire && timer?.leadId) {
                    onExpire(timer.leadId);
                }
            }
        }, 1000);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [timer, onExpire]);

    if (!timer || remaining <= 0) {
        return null;
    }

    return (
        <div className='chat-timer' role='status' aria-live='polite'>
            <span className='chat-timer__icon'>
                <TimerIcon />
            </span>
            <div className='chat-timer__content'>
                <span className='chat-timer__title'>Автопилот готовит ответ</span>
                <span className='chat-timer__subtitle'>осталось {formatDuration(remaining)}</span>
            </div>
        </div>
    );
};
